import React, { useEffect, useRef } from 'react';
import './CodeDisplay.css'; 

function CodeDisplay({ title, code, autoScroll = false }) {
  const preRef = useRef(null);

  // Scroll to bottom whenever the code changes if autoScroll is true
  useEffect(() => {
    if (autoScroll && preRef.current) {
      preRef.current.scrollTop = preRef.current.scrollHeight;
    }
  }, [code, autoScroll]);

  return (
    <div>
      {title && <h3 style={{ color: '#FFF' }}>{title}</h3>}
      <pre
        ref={preRef}
        className="code-display"
        style={{
          backgroundColor: '#272822',
          color: '#f8f8f2',
          padding: '10px',
          borderRadius: '5px',
      
          /* prevent the card from stretching horizontally */
          maxWidth: '100%',
          overflowX: 'auto',
          maxHeight: '200px',
          overflowY: 'scroll',
      
          /* hide native scrollbars in Firefox / Edge */
          msOverflowStyle: 'none',
          scrollbarWidth:   'none',
      
          /* --- added to wrap very long tokens (e.g. long URLs) --- */
          whiteSpace: 'pre-wrap',   // keep line‑breaks but allow wrapping
          wordBreak:  'break-all'   // force‑break inside unbroken strings
        }}
      >
        <code>{code}</code>
      </pre>
    </div>
  );
}

export default CodeDisplay;